import type { ComponentProps, FunctionComponent } from 'react';
import { lazy, Suspense } from 'react';

import { AgentAttributionsSkeleton } from './AgentAttributionsSkeleton';

// Loaded on demand: the attributions reach into the job architecture and position features, whose barrels import this one.
const LazyAgentAttributions = lazy(async () => {
    const { AgentAttributions } = await import('./library/AgentAttributions');

    return { default: AgentAttributions };
});

type Props = ComponentProps<typeof LazyAgentAttributions>;

/** Where an agent is recommended in an architecture, for an automation tile outside this feature. */
export const AgentAttributions: FunctionComponent<Props> = (props) => (
    <Suspense fallback={<AgentAttributionsSkeleton />}>
        <LazyAgentAttributions {...props} />
    </Suspense>
);
